import React, { useState } from 'react'
import ImageBoxPagination from '../../../../component/imageDetail/imageBoxPagination'
import MainImage from '../mainImage'
import type { IQueryParams } from '../interface'
import OtherOperation from './actionGroup'
import { IMAGE_DETAIL_TAB } from '../infoView'
import { ImageDetailContext } from '../content'
import styles from './index.module.less'

export type OperationViewProps = {
    imgInfoList: Array<any>
    setImgInfoList:any,
    setInnerIndex: React.Dispatch<React.SetStateAction<number>>,
    innerIndex: number,
    queryParams:IQueryParams,
    onInit:()=>void,
    currentImage:any,
    setBanOperation:(arg:boolean)=>void,
    onOuterChange:(index: number)=>void,
    maxListLength:number,
    currentIndexInList:number,
    tabValue: IMAGE_DETAIL_TAB,
    isAnnotate:boolean,
    setIsAnnotate: any,
}

export default ({
  imgInfoList,
  setImgInfoList,
  setInnerIndex,
  queryParams,
  onInit,
  currentImage,
  setBanOperation,
  onOuterChange,
  maxListLength,
  currentIndexInList,
  tabValue,
  isAnnotate,
  setIsAnnotate,
  innerIndex,
}:OperationViewProps) => {
  const [showBox, setShowBox] = useState(localStorage.hideBoxVisible ? localStorage.hideBoxVisible === 'true' : true)
  const [showNoteLabel, setShowNoteLabel] = useState(localStorage.showNoteLabel ? localStorage.showNoteLabel === 'true' : true)
  const [scale, setScale] = useState(null)

  const onShowBox = (val) => {
    localStorage.hideBoxVisible = val
    setShowBox(val)
  }

  const onShowNoteLabel = (val) => {
    localStorage.showNoteLabel = val
    setShowNoteLabel(val)
  }
  return <div className={styles.mnImageDetailOperationView}>
    <div className={styles['img-actions']}>
      <div className={styles['action-pagination']}>
        <ImageBoxPagination
          imgInfoList={imgInfoList}
          setImgInfoList={setImgInfoList}
          setInnerIndex={setInnerIndex}
          collectId={queryParams.collectId}
          init={onInit}
          currentImage={currentImage}
        />
      </div>
      <MainImage
        content={ImageDetailContext}
        innerIndex={innerIndex}
        setInnerIndex={setInnerIndex}
        imgInfoList={imgInfoList}
        scale={scale}
        setScale={setScale}
        maxListLength={maxListLength}
        currentImage={currentImage}
        setBanOperation={setBanOperation}
        onOuterChange={onOuterChange}
        currentIndexInList={currentIndexInList}
        showNoteLabel={showNoteLabel}
        showBox={showBox}
      />
    </div>
    <OtherOperation
      scale={scale}
      setScale={setScale}
      tabValue={tabValue}
      currentImage={currentImage}
      showBox={showBox}
      showNoteLabel={showNoteLabel}
      onShowNoteLabel={onShowNoteLabel}
      onShowBox={onShowBox}
      imgInfoList={imgInfoList}
      sampleData={{}}
      isAnnotate={isAnnotate}
      setIsAnnotate={setIsAnnotate}
    />
  </div>
}
